import { rootPath, route } from 'frontend/inertia/routes'

// Unpoly-served pages and external URLs the footer links to.

// mirrors career_frontend_root
const careerRootPath = route('/:site')

export const portalPath = {
  learning: rootPath,
  training: (): string => careerRootPath('ausbildung'),
  jobs: (): string => careerRootPath('jobs'),
}

export const staticPagePath = {
  // mirrors about_us_frontend_static_page
  aboutUs: route('/ueber_uns'),
  // mirrors internal_jobs_frontend_static_page
  internalJobs: route('/jobs-bei-studyflix'),
  // mirrors become_a_partner_frontend_static_page
  becomeAPartner: route('/partner-werden'),
  // mirrors e_learning_frontend_static_page
  eLearning: route('/e-learning'),
  // mirrors imprint_frontend_static_page
  imprint: route('/impressum'),
  // mirrors terms_frontend_static_page
  terms: route('/agb'),
  // mirrors privacy_frontend_static_page
  privacy: route('/datenschutz'),
  // mirrors about_studyflix_frontend_static_page
  aboutStudyflix: route('/ueber-studyflix'),
}

// mirrors video_platform_frontend_partners
export const partnersPath = route('/partner')

export const appStoreUrl = {
  // mirrors Settings.app_store_links.ios
  ios: 'https://apps.apple.com/de/app/studyflix-deine-lernapp/id1514546785',
  // mirrors Settings.app_store_links.android
  android: 'https://play.google.com/store/apps/details?id=de.studyflix.studyflix',
}
